import type { BestContentsApiDto } from '__generated__/api/unauth/types.gen';

import { ROUTES } from '@/constants';

import { formatDateLabel } from '../../utils';
import { SearchContentsCard } from '../SearchContentsCard';
import { SearchEmptyResults } from '../SearchEmptyResults';

export function PolicyInfoList({ items }: { items: BestContentsApiDto[] }) {
  if (items.length < 1) return <SearchEmptyResults />;

  return (
    <ul className="flex flex-col gap-12 pb-20 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100 mobile-tablet:pb-0">
      {items.map((item) => (
        <li key={item.bestContentsIdIdx ?? item.bestContentsId}>
          <SearchContentsCard
            imageSrc={item.emojiFileUrl || item.fileUrl}
            title={item.title}
            content={item.contentPreview}
            daysAgo={formatDateLabel(item.createAt)}
            link={ROUTES.POLICY_INFO_DETAIL.pathname({
              idIdx: item.bestContentsIdIdx ?? '',
            })}
          />
        </li>
      ))}
    </ul>
  );
}
